import styled from 'styled-components'
import PropTypes from 'prop-types'

const gridArea = 'btm'
const Wrap = styled.div`
  grid-area: ${gridArea};
  background-color: ${({ bgColor }) => bgColor};
`
const Bottom = ({ children, bgColor = 'white', ...rest }) => {
  return (
    <Wrap bgColor={bgColor} {...rest}>
      {children}
    </Wrap>
  )
}

Bottom.propTypes = {
  bgColor: PropTypes.string,
  children: PropTypes.node.isRequired
}
Bottom.slotName = 'PageBottom'

export { Bottom, gridArea }
